"use client"

import { useEffect } from "react"
import { cleanupOldRecordings } from "@/services/recording-db"
import { useMeetingRecordingStore } from "@/stores/use-meeting-recording-store"

export function GlobalMeetingRecording() {
  const { finishRecording, restorePendingUpload } = useMeetingRecordingStore()

  useEffect(() => {
    const init = async () => {
      await cleanupOldRecordings()
      await restorePendingUpload()
    }
    init()
  }, [restorePendingUpload])

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      const { isRecording } = useMeetingRecordingStore.getState()
      if (isRecording) {
        e.preventDefault()
        e.returnValue = "You have an active recording. Are you sure you want to leave?"
      }
    }

    window.addEventListener("beforeunload", handleBeforeUnload)

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload)
      void finishRecording("page_unmounted")
    }
  }, [finishRecording])

  return null
}

export default GlobalMeetingRecording
